import { createFileRoute } from "@tanstack/react-router";
import TreatmentSectorsList from "@/components/field/setup/TreatmentSectors";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/treatment-sectors/",
)({
    component: TreatmentSectorsListPane,
});

function TreatmentSectorsListPane() {
    return <TreatmentSectorsList />;
}
